export default "__VITE_ASSET__CkH$RBu6__"